<template>
  <div>
    <v-dialog v-model="dialog" width="700" :scrollable="false">
      <template v-slot:activator="{ on, attrs }">
        <!-- Aqui vem a imagem definida no uso do componente -->

        <span v-bind="attrs" v-on="on" @click="openModal()">
          <slot>
            <!-- Fallback -->
            <v-btn color="red lighten-2" dark> Click Me </v-btn>
          </slot>
        </span>
      </template>

      <v-card class="">
        <v-icon
          style="display: inline"
          @click="dialog = false"
          aria-label="Close"
          large
          color="red"
        >
          mdi-close
        </v-icon>

        <v-img
          v-if="hasUrl"
          contain
          max-height="600"
          :src="normalizedUrl"
        ></v-img>

        <div v-if="hasUrl">
          <a :href="normalizedUrl" target="_blank">
            <v-img v-if="imageUrl" :src="imageUrl" alt="Downloadable Image" />
            <v-btn
              style="align-self: center"
              color="secondary"
              dark
              v-else
              @click="openModal"
            >
              <v-icon color="blue">mdi-download</v-icon>
            </v-btn>
          </a>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "ShowImage",

  props: {
    url: { type: String, default: null },
  },

  data() {
    return {
      dialog: false,
      imageUrl: null,
    };
  },

  computed: {
    hasUrl() {
      return typeof this.url === "string" && this.url.trim() !== "";
    },
    normalizedUrl() {
      return this.hasUrl ? this.url : "";
    },
  },

  methods: {
    openModal() {
      if (!this.hasUrl) {
        return;
      }
      this.dialog = true;
    },
    downloadImage() {
      if (!this.hasUrl) {
        return;
      }
      const link = document.createElement("a");
      link.href = this.normalizedUrl;
      link.download = this.getFileName(this.normalizedUrl);
      link.click();

      this.imageUrl = this.normalizedUrl;
    },
    getFileName(url) {
      return url.split("/").pop();
    },
  },
};
</script>

<style></style>
